<template>
    <div
        class="modal fade"
        id="archiveDesignModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="archiveDesignModalLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
    >
        <div class="modal-dialog modal-dialog-centered archive_design_modal" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title" id="archiveDesignModalLabel">
                        Archive Design
                    </h4>
                    <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        @click="closeModal"
                    >
                        <span aria-hidden="true"><img src="/maincss/images/close_popup.svg" alt="cross icon"></span>
                    </button>
                </div>
                <div class="modal-body">
                    <p class="mb-3">
                        You're About To Archive "{{ designName }}". Add A Note
                        To Help You Understand Why This Design Is Being
                        Archived.
                    </p>

                    <div
                        class="alert_box"
                    >
                    <img src="/maincss/images/yellow-indication.svg" alt="yellow indication icon">
                       <p> This design will be moved to your archived designs. It
                        will still be able to view it, but it won't appear in
                        active designs.</p>
                    </div>

                    <div class="form-group">
                        <label for="archiveNotes" class="text_area_label">Archive Notes</label>
                        <textarea
                            id="archiveNotes"
                            class="text_area_field"
                            rows="4"
                            placeholder="Notes"
                            v-model="archiveNotes"
                        ></textarea>
                    </div>
                </div>
                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                        @click="closeModal"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        class="btn save-blue-btn text_white"
                        @click="confirmArchive"
                        :disabled="isLoading"
                    >
                        <span v-if="isLoading">Processing...</span>
                        <span v-else>Archive Design</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ArchiveDesignModal",
    props: {
        designId: {
            type: [Number, String],
            default: null
        },
        designName: {
            type: String,
            default: ""
        }
    },
    data() {
        return {
            archiveNotes: "",
            isLoading: false
        };
    },
    watch: {
        designId(newVal) {
            if (newVal) {
                this.archiveNotes = "";
            }
        }
    },
    methods: {
        closeModal() {
            this.archiveNotes = "";
            this.isLoading = false;
            /* eslint-disable */
            $("#archiveDesignModal").modal("hide");
            /* eslint-enable */
        },
        confirmArchive() {
            if (this.designId) {
                this.$emit("archive-confirmed", {
                    designId: this.designId,
                    archiveNotes: this.archiveNotes
                });
            }
        },
        openModal() {
            /* eslint-disable */
            $("#archiveDesignModal").modal("show");
            /* eslint-enable */
        }
    },
    mounted() {
        this.$nextTick(() => {
            /* eslint-disable */
            $("#archiveDesignModal").on("hidden.bs.modal", () => {
                this.archiveNotes = "";
                this.isLoading = false;
            });
            /* eslint-enable */
        });
    }
};
</script>

